import { Timestamp } from '@angular/fire/firestore';
import { CrudModel } from '@core/crud/crud-model.interface';
import { AddressData } from 'zafirus-pick-location';

export type Floor={
  uid?: string;
  number:string;
  units:string[];
} 
export type Tower={
  uid?: string;
  name:string;
  floors:Floor[];
} 

export interface CocheraNivel{
  nivel:string;
  unidades:Cochera[];
}
export interface CocheraSinNivel{
  niveles: number;
  unidades:Cochera[];
}

export interface Cochera{
  numero:number;
  ocupada:boolean;
  //etiqueta personalizada, se asigna al crear el consorcio. Es solo para mostrar: la cochera se identifica por nivel + numero
  label?:string;
}

//unidades de cochera de un nivel. Sin niveles se ignora el nivel
function getUnidadesCocheraNivel(cocheras: CocheraNivel[] | CocheraSinNivel | undefined, nivel: string | number | undefined): Cochera[] {
  if (!cocheras) return [];
  return (Array.isArray(cocheras)
    ? cocheras.find(c => String(c.nivel) === String(nivel))?.unidades
    : cocheras.unidades) ?? [];
}

//busca la unidad de cochera en la estructura del consorcio por nivel + numero
export function findCocheraUnidad(cocheras: CocheraNivel[] | CocheraSinNivel | undefined, nivel: string | number | undefined, numero: string | number | undefined): Cochera | undefined {
  if (numero === undefined || numero === null || numero === '') return undefined;
  return getUnidadesCocheraNivel(cocheras, nivel).find(u => Number(u.numero) === Number(numero));
}

//busca la unidad de cochera por numero o por etiqueta, para los campos que se escriben a mano.
//son equivalentes porque al crear el consorcio una etiqueta no puede coincidir con el numero ni con la etiqueta de otra cochera del mismo nivel
export function findCocheraByNumeroOLabel(cocheras: CocheraNivel[] | CocheraSinNivel | undefined, nivel: string | number | undefined, valor: string | number | undefined): Cochera | undefined {
  if (valor === undefined || valor === null) return undefined;
  const v = String(valor).trim().toUpperCase();
  if (!v) return undefined;
  const unidades = getUnidadesCocheraNivel(cocheras, nivel);
  return unidades.find(u => String(u.numero) === v) ?? unidades.find(u => u.label?.toUpperCase() === v);
}

//etiqueta de la cochera en la estructura del consorcio (undefined si no tiene)
export function getCocheraLabel(cocheras: CocheraNivel[] | CocheraSinNivel | undefined, nivel: string | number | undefined, numero: string | number | undefined): string | undefined {
  return findCocheraUnidad(cocheras, nivel, numero)?.label || undefined;
}

//devuelve la cochera con el label de la estructura del consorcio, para guardarlo junto al numero.
//si la unidad no tiene label no agrega el campo (firestore no acepta undefined)
export function withCocheraLabel<T extends { nivel?: string | number, numero?: string | number, label?: string }>(cochera: T, cocheras: CocheraNivel[] | CocheraSinNivel | undefined): T {
  const label = getCocheraLabel(cocheras, cochera.nivel, cochera.numero);
  return label ? { ...cochera, label } : cochera;
}


export type Amenity={
  uid?: string;
  name:string;
  aditional:string;
}
export type Service={
  uid?: string;
  providerId?: string;
  name:string;
  legalName:string;
  info:string;
}
export type UrgentService={
  uid?: string;
  providerId?: string; //ver nota en Service.providerId
  name:string;
  legalName:string;
  fulltime?:boolean;
  whatsapp:string;
}
export type agentQuestion={
  uid?: string;
  updatedAt:Date|Timestamp;
  question:string;
  answer:string;
  isDefault?:boolean;
}

export const agentByDefault: agentQuestion[] = [
  // {
  //   question: '¿Por qué las expensas subieron de valor?',
  //   answer: "Estimado consorcista, por favor revise las expensas que nuestra administración hizo llegar a su apartamento, allí se detallan todos los gastos del edificio y podrá comprobar qué gastos tuvieron mayor incidencia este mes. Muchas gracias.",
  //   updatedAt: new Date(),
  //   isDefault:true
  // },
  // {
  //   question: '¿Este gasto corresponde a expensas ordinarias o extraordinarias?',
  //   answer: "Estimado consorcista, la última ley de alquileres no distingue entre expensas ordinarias y extraordinarias sino que deja librada a las partes esa distinción. Por favor póngase en contacto con su inmobiliaria o el propietario de su inmueble si cree que ellos deberían hacerse cargo de algún gasto de las expensas. Muchas gracias.",
  //   updatedAt: new Date(),
  //   isDefault:true
  // },
  // {
  //   question: '¿Cuál es la fecha de vencimiento de las expensas?',
  //   answer: "Estimado consorcista, por favor revise las expensas que nuestra administración hizo llegar a su apartamento, allí se detallan todas las fechas relevantes para realizar los pagos correspondientes. Muchas gracias.",
  //   updatedAt: new Date(),
  //   isDefault:true
  // },
  // {
  //   question:'¿Cómo son las mudanzas al edificio?',
  //   answer:"",
  //   updatedAt: new Date(),
  
  //   isDefault:true
  // },
  // {
  //   question:'¿Cómo accedo a la azotea?',
  //   answer:"",
  //   updatedAt: new Date(),
  //   isDefault:true
  // },
]

 //se refiere a la etiqueta que genera una fila vacía

export const labelPersonalizado='Personalizado';

export const amenitiesByDefault:Amenity[]=[
  {name:labelPersonalizado,aditional:''},
  {name:'Seguridad 24/7',aditional:''},
  {name:'Cámaras de vigilancia',aditional:''},
  {name:'Control de acceso con tarjetas o biometría',aditional:''},
  {name:'Portería y recepción',aditional:''},
  {name:'Gimnasio',aditional:''},
  {name:'Pileta',aditional:''},
  {name:'Solárium',aditional:''},
  {name:'SUM (Salón de Usos Múltiples)',aditional:''},
  {name:'Parrillas y quinchos',aditional:''},
  {name:'Terraza con vistas',aditional:''},
  {name:'Lounge o sala de estar',aditional:''},
  {name:'Sala de juegos para niños',aditional:''},
  {name:'Sala de juegos para adultos (pool, ping pong)',aditional:''},
  {name:'Coworking',aditional:''},
  {name:'Biblioteca o sala de estudio',aditional:''},
  {name:'Salas de reuniones',aditional:''},
  {name:'Lavadero común',aditional:''},
  {name:'Lockers o bauleras',aditional:''},
  {name:'Bicicleteros',aditional:''},
  {name:'Cocheras fijas y móviles',aditional:''},
  {name:'Espacios para carga de autos eléctricos',aditional:''},
  {name:'Jardines y espacios verdes',aditional:''},
  {name:'Plaza interna o parque infantil',aditional:''},
  {name:'Circuito de running o caminata',aditional:''},
  {name:'Canchas deportivas (tenis, fútbol, paddle, básquet)',aditional:''},
  {name:'Sector de fogones o fire pits',aditional:''},
  {name:'Espacio para mascotas',aditional:''},
  {name:'Restaurante interno o bar',aditional:''},
  {name:'Valet parking',aditional:''},
  {name:'Concierge',aditional:''}
 ];

  export const serviceByDefault:Service[]=[
  {name:labelPersonalizado,legalName:'',info:''},
  {name:'Desinfección',legalName:'',info:''},
  {name:'Matafuegos',legalName:'',info:''},
  {name:'Limpieza',legalName:'',info:''},
  {name:'Portero',legalName:'',info:''},
  {name:'Encargado',legalName:'',info:''},
  {name:'Seguridad',legalName:'',info:''},
  {name:'Alarma',legalName:'',info:''},
  {name:'Bombista',legalName:'',info:''},
  {name:'Mantenimiento',legalName:'',info:''},
  {name:'Ascensor',legalName:'',info:''},
 ];
 export const urgentServiceByDefault:UrgentService[]=[
  {name:labelPersonalizado,legalName:'',whatsapp:''},
  {name:'Emergencias médicas',legalName:'',whatsapp:''},
  {name:'Cerrajero',legalName:'',whatsapp:''},
  {name:'Servicio de llaves electrónicas',legalName:'',whatsapp:''},
  {name:'Plomero',legalName:'',whatsapp:''},
  {name:'Gasista matriculado',legalName:'',whatsapp:''},
  {name:'Electricista',legalName:'',whatsapp:''},
  {name:'Bombista',legalName:'',whatsapp:''},
  {name:'Ascensorista',legalName:'',whatsapp:''},
  {name:'Encargado',legalName:'',whatsapp:''},
  {name:'Guardia de seguridad',legalName:'',whatsapp:''},
  {name:'Portería',legalName:'',whatsapp:''},
  {name:'Alarma',legalName:'',whatsapp:''},
 ];

/*
 * Last assignment used on the expenses-upload page, saved so the next
 * PDF starts preloaded. `assignments[i]` is the key chosen for the
 * i-th coupon of the PDF: a department key ("tower|floor|unit"), a
 * parking key ("cochera|level|number"), an extra key ("extra|number")
 * or "__ignore__".
 */
export interface ExpensesMapping {
  hasParkings: boolean;
  assignments: string[];
  updatedAt: Date | Timestamp;

  // All absent on mappings saved before extras / shared coupons existed.
  singleParkingCoupon?: boolean;
  extrasCount?: number;
}

export type FloorScheme = 'number' | 'letter' | 'other';

export type fileTypeRules='pdf' | 'image';

export interface Consorcio extends CrudModel {
  name: string;
  nro:string;
  administrationUserId: string;
  administrationWsp?:string;
  location: AddressData;
  uid:string;
  cuit:string;
  createdAt:Date;
  agentPersistence?:number;
  //si el consorcio tiene torres o no, en caso de no tener se asume que es un edificio tradicional sin torres
  hasTowers:boolean;
  towers?:Tower[]; //siempre con hasTowers en true, si es false se ignora este campo
  floors?:Floor[]; //si el edificio no tiene torres, se cargan los pisos aca, si tiene torres se ignora este campo y se cargan los pisos dentro de cada torre
  insurance?:{legalName:string, info:string;};
  floorScheme: FloorScheme;
  rules?:[{
    file?:string;
    updatedAt:Date;
    fileType?:fileTypeRules;
  }]
  //representa si va a haber niveles diferenciados o si se cuentan todas las cocheras juntas
  garageLevels: boolean;
  cocheras?: (CocheraNivel[] | CocheraSinNivel);
  //pedidos de copia de llave (AF298): prestador de llaves (de "mis prestadores") e instrucciones que se le mandan al consorcista al aceptar
  keyService?: { providerId?: string; instructions?: string; updatedAt?: Date | Timestamp };
  expensesMapping?: ExpensesMapping;
  //código del consorcio en el sistema de la administración (ej. "C091"). Lo escribe t-consorcios-api sola la primera vez que logra identificar el consorcio por nombre y dirección; no se muestra ni se edita en ningún formulario. Si el matching falla, se carga a mano en Firestore.
  externalCode?: string;
}


export const MODELNAME = 'consorcios';
export type Model = Consorcio;